import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {MatTreeModule} from '@angular/material/tree';
import {MatIconModule} from '@angular/material/icon';
import { AppComponent } from './app.component';
import { OneProductComponent } from './components/one-product/one-product.component';
import { ProductsByCategoryComponent } from './components/products-by-category/products-by-category.component';
import { ProductAvatarComponent } from './components/product-avatar/product-avatar.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WebiImageComponent } from './components/webi-image/webi-image.component';
import {MatPaginatorModule} from '@angular/material/paginator';
import { SearchComponent } from './components/search/search.component';

const appRoutes = [
  {path: 'search', component: SearchComponent},
  {path: ':lang/search', component: SearchComponent},
  {path: ':groupId', component: ProductsByCategoryComponent},
  {path: 'product/:productId', component: OneProductComponent},
  {path: ':lang/product/:productId', component: OneProductComponent},
  {path: ':lang/:groupId', component: ProductsByCategoryComponent},
];

@NgModule({
  declarations: [
    AppComponent,
    OneProductComponent,
    ProductsByCategoryComponent,
    ProductAvatarComponent,
    ProductListComponent,
    WebiImageComponent,
    SearchComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
    BrowserAnimationsModule,
    MatTreeModule,
    MatIconModule,
    MatPaginatorModule
  ],
  providers: [
    WebiImageComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
